
        var result = require("!!../../../../node_modules/css-loader/index.js!./member-perks-admin.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/member-perks-admin/member-perks-admin.component.css
// module id = 613
// module chunks = 0